// Fin du dernier niveau : fenêtre qui annonce la batterie longue durée gagnée, avec un seul bouton « Continuer ».
// Le bouton pour rejouer est à part, dans le cadre photo (voir ui/overlay.js#showFinale) : cette fenêtre ne bloque rien ensuite.
import { $ } from './dom.js';
import { createDialog } from './dialog.js';

/** @param {{ t: (key: string, params?: object) => string }} deps */
export function createFinaleDialog({ t }) {
  const text = $('finaleText');
  const dialog = createDialog($('finaleOverlay'), { focus: '#btnFinaleContinue' });
  return {
    open() {
      text.textContent = t('finale.popup');
      return dialog.open();
    },
    close: dialog.close,
    isOpen: dialog.isOpen,
  };
}
